import { InstitutionBaseURL } from "./baseURL";
import { commonapi } from "./commonAPI";

// Students
export const studentCreationApi = async (reqBody, reqHeader) => {
  return await commonapi(
    "POST",
    `${process.env.REACT_APP_INSTITUTION_BASEURL}/add-student`,
    reqBody,
    reqHeader
  );
};

export const getAllStudents = async (page, limit, search, reqHeader) => {
  const queryParams = `?page=${page + 1}&limit=${limit}&search=${encodeURIComponent(search)}`;
  return await commonapi(
    "GET",
    `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-students${queryParams}`,
    "",
    reqHeader
  );
};

export const updateStudent = async (userId, reqBody, reqHeader) => {
  return await commonapi(
    "PUT",
    `${process.env.REACT_APP_INSTITUTION_BASEURL}/update-student/${userId}`,
    reqBody,
    reqHeader
  ); //Update Role
};

export const deleteStudent = async (id, reqHeader) => {
  return await commonapi(
    "PUT",
    `${process.env.REACT_APP_INSTITUTION_BASEURL}/delete-student/${id}`,
    "",
    reqHeader
  ); //Delete Role
};
